import _ from "lodash";
import LocalSettingsProtoDepricated from "../../gd/settings/local-settings/local-settings-v3";
import {ViewType} from "../../gd/const/views/view-type";

// Keeps all local settings for a project
export default class ProjectLocalSetting extends LocalSettingsProtoDepricated {

    public views        : any
    public defaultView  : any

    constructor(projectId:ID) {
        super("project." + projectId,{});

        // Code below is patch to TS inheritance
        const localStorageValues = this._readFromLocalStorage();
        this.views              = _.get(localStorageValues, 'views', {});
        this.defaultView        = _.get(localStorageValues, 'defaultView', null);
        // end
    }

    deleteView(projectViewId:ID) {
        if (this.views[projectViewId]) {
            delete this.views[projectViewId];
        }
        this.save();
    }

    // reset (null) appSettings for current view in local setting
    resetViewAppSettings(viewId:ID | ViewType) {

        if (this.views[viewId]) {
            //reset appSettings
            const viewSettings = this.views[viewId].appSettings = null;
            this.save();
        }

    }

    normalize(values:any) {
        this.views =        _.get(values, 'views', {});
        this.defaultView =  _.get(values, 'defaultView', null);
    }

    toObject() {
        return {
            views:          this.views,
            defaultView:    this.defaultView
        };
    }
}
